import { checkClaims, decodeJwtWeb } from '@eventr/common'
import {
    Gutters,
    Loading,
    MainButton,
    Typography,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { DataAPI } from '../../../data/Data'
import i18n from '../../../i18n/i18next'
import { Paths } from '../../../routes'
import { useBoundStore } from '../../../state/bound.store'
import { OrgSelector } from '../../account/changeOrg/orgSelector'
import { logEvent } from '../../firebase/firebase'
import { NavigationView } from '../../layout/NavigationView'
import { useGuestStore } from '../guest.store'
import { useDuplicateContext } from '../state/duplicate.context'

export const SelectTeamPage = () => {
    const setOrg = useDuplicateContext((s) => s.setOrg)
    const { org, setName } = useDuplicateContext(
        useShallow((s) => {
            return {
                org: s.selectedOrg,
                setName: s.setOverrideName,
            }
        })
    )
    const [orgs, setOrgs] = useState(undefined)
    const { profile } = useBoundStore(
        useShallow((s) => {
            return { profile: s.profile }
        })
    )

    useEffect(() => {
        const fetchItins = async () => {
            const promises = []
            profile.organisations.forEach((org) => {
                promises.push(DataAPI.getItineraryMap(org.name, true))
            })
            const itinMaps = await Promise.allSettled(promises)
            const sortedOrgs = profile.organisations.map((org, i) => {
                if (itinMaps[i].status === 'rejected') {
                    return {
                        ...org,
                        disabled: true,
                    }
                }

                const claims = decodeJwtWeb(
                    (itinMaps[i] as any).value.headers['x-eventr-claims']
                )

                return {
                    ...org,
                    disabled: !checkClaims(
                        claims.claims as any,
                        ['/'],
                        ['createItinerary']
                    ),
                    itinMap: (itinMaps[i] as any).value.data,
                }
            })
            setOrgs(sortedOrgs)
        }
        fetchItins()
    }, [profile.organisations])

    const footer = (
        <Stack padding="16px">
            <MainButton
                id="continueButton"
                style={{ width: '100%' }}
                onClick={async () => {
                    logEvent('guest_dup_selectItin', {
                        code: useGuestStore.getState().guestCode,
                    })
                    setName(
                        useGuestStore.getState().guestData.map_entry
                            .itinerary_name
                    )

                    window.pushPath(
                        '/guestdup/itineraryselect?orgid=' + org.name
                    )
                }}
                text={i18n.t('general.continue')}
                disabled={org ? false : true}
            />
        </Stack>
    )

    return (
        <NavigationView
            navigationBarTitle={i18n.t('guest.duplicateItinerary')}
            navigationBarSubtitle={i18n.t('guest.selectTeamSubTitle')}
            backButtonAction={() => {
                window.pushPath(Paths.home)
            }}
            usePageTransition
            footer={footer}
        >
            <Gutters>
                <Stack spacing={'24px'}>
                    <Stack>
                        <Typography variant="mobileH3">
                            {i18n.t('guest.selectTeam')}
                        </Typography>
                        <Typography variant="bodyRegular">
                            {i18n.t('guest.selectTeamExplanaition')}
                        </Typography>
                    </Stack>
                    {orgs === undefined && (
                        <Stack alignItems={'center'}>
                            <Loading />
                        </Stack>
                    )}
                    {orgs && (
                        <OrgSelector
                            organisations={orgs}
                            selectedOrg={org}
                            onSelect={(org) => {
                                setOrg(org, org.itinMap)
                            }}
                        />
                    )}
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
